import React from 'react';
import PropTypes from 'prop-types';
import { Card, Column, Row, Typography } from '@tempmee/react';
import { formatCycleDate } from '../../../../domain/Awards';

/**
 * The cycle's dates, as label-over-value pairs.
 *
 * Not a `<dl>`: Box's `as` accepts only div/span, so dl/dt/dd would mean
 * passing props the design system does not support.
 *
 * The cycle's name is absent on purpose — it is the page title just above.
 */
const SummaryItem = ({ term, value }) => (
  <Column gap={1}>
    <Typography variant="caption" uppercase className="text-text-secondary">
      {term}
    </Typography>
    <Typography variant="body1">{value}</Typography>
  </Column>
);

SummaryItem.propTypes = {
  term: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export const CycleSummary = ({ cycle }) => (
  <Card outline>
    <Row px={6} py={5} gap={12} wrap="wrap">
      <SummaryItem term="Applications open" value={formatCycleDate(cycle.applicationOpenDate)} />
      <SummaryItem term="Applications close" value={formatCycleDate(cycle.applicationCloseDate)} />
      <SummaryItem term="Cycle ends" value={formatCycleDate(cycle.cycleEndDate)} />
    </Row>
  </Card>
);

CycleSummary.propTypes = {
  cycle: PropTypes.shape({
    applicationOpenDate: PropTypes.string.isRequired,
    applicationCloseDate: PropTypes.string.isRequired,
    cycleEndDate: PropTypes.string.isRequired,
  }).isRequired,
};
